import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const ANALYST_ALLOWED_PATH_PREFIXES = ['/dashboard', '/client-intelligence', '/retainers', '/clients'];

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading, isViewer, isAnalyst } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-cream flex items-center justify-center">
        <div className="font-body text-text-secondary">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && isViewer) {
    return <Navigate to="/dashboard" replace />;
  }

  // Analyst: allow only client-intelligence, retainers, clients (and their sub-routes)
  if (isAnalyst) {
    const path = location.pathname;
    const allowed = ANALYST_ALLOWED_PATH_PREFIXES.some(p => path === p || path.startsWith(p + '/'));
    if (!allowed) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
